<template>
  <div class="lunisolar-wrap">
   <span :class="[query_type===1?'query_type':'']" @click="change(1)">按日</span>
   <span :class="[query_type===2?'query_type':'']" @click="change(2)" >按月</span>
  </div>
</template>

<script>
export default{
  name:'lunisolar',
  props:{
    query_type:Number
  },
  methods:{
    change(val){
      this.$emit("change",val)
    }
  }
}
</script>

<style lang="scss" scoped>
 .lunisolar-wrap{
   // background: #fff;
   line-height: 56px;
   width: 202px;
   display: flex;
   // border: 2px solid #fff;
   border-radius: 8px;
   span{
     flex:1;
     // background: #fff;
     text-align: center;
     color: #fff;
     font-size: 28px;
   }
   // span:nth-child(1){
   //   border-radius: 6px 0px 0px 6px;
   // }
   // span:nth-child(2){
   //   border-radius: 0px 6px 6px 0px;
   // }
   .query_type{
     background:#fff;
     color: #691BFF;
     border-radius: 8px
   }
 }
</style>
